<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <div class="ibox-content m-b-sm border-bottom">
            <div class="row form-horizontal">
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Delivery ID </label>
                    <div class="col-sm-4">
                        <div>
                            <el-input clearable v-model="deliveryId" name="search"></el-input>
                        </div>
                    </div>
                </div>
                <div class="form-group margin-0">
                    <label class="col-sm-2 control-label"> Pickup Redemption Centre </label>
                    <div class="col-sm-4">
                        <div>
                            <el-select clearable v-model="endGiftStoreId" name="endGiftStoreId">
                                <el-option v-for="item in giftStoreMap" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-12 textRight">
                        <div class>
                            <el-button type="primary" @click="search">{{
                                $t("message.Search")
                            }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-content">
                        <div class="row table-responsive" style="padding-bottom: 60px">
                            <div class="col-xs-12">
                                {{ total }}{{ $t("message.datagridresult") }}
                            </div>
                            <el-table :data="rows" border style="width: 100%" ref="multipleTable" row-key="id"
                                :cell-class-name="cell">
                                <el-table-column prop="deliveryNo" label="Delivery No">
                                </el-table-column>
                                <el-table-column prop="totalQty" label="Total Quantity">
                                </el-table-column>
                                <el-table-column prop="endGiftStoreName" label="Pickup Redemption Centre Name" width="250">
                                </el-table-column>
                                <el-table-column prop="arrangeUserName" label="Arranged By">
                                </el-table-column>
                                <el-table-column prop="createdAt" label="Created Date">
                                </el-table-column>
                                <el-table-column label="Status" prop="status" :show-overflow-tooltip="true">
                                    <template slot-scope="scope">
                                        {{ statusMap[scope.row.status] }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="" width="190">
                                    <template slot-scope="scope
                                    ">
                                        <el-row v-if="scope.row.status == 0">
                                            <el-col :span="14">
                                                <el-popconfirm title="Are you sure you want to modify the status?"
                                                    confirmButtonText="Yes" cancelButtonText="No"
                                                    @confirm="updateStatusEvent(1, scope.row.id)">
                                                    <el-button size="mini" type="primary" style="width: 92px;"
                                                        slot="reference">Complete
                                                    </el-button>
                                                </el-popconfirm>
                                            </el-col>

                                            <el-col :span="10">
                                                <el-popconfirm title="Are you sure you want to modify the status?"
                                                    confirmButtonText="Yes" cancelButtonText="No"
                                                    @confirm="updateStatusEvent(2, scope.row.id)">
                                                    <el-button size="mini" type="danger" style="width: 72px;"
                                                        slot="reference">Cancel
                                                    </el-button>
                                                </el-popconfirm>
                                            </el-col>
                                        </el-row>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Action" width="170" fixed="right">
                                    <template slot-scope="scope">
                                        <div
                                            style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
                                            <el-button size="mini" @click="exporttDeliveryNote(scope.row)">View Delivery
                                                Note</el-button>
                                        </div>

                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-col :span="24" class="el-table_footertoolbar">
                                <el-pagination layout="total, sizes, prev, pager, next, jumper"
                                    @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                    :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :total="total"
                                    style="float: right">
                                </el-pagination>
                            </el-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import config from "../config";
import StatusBtn from "../components/common/statusBtn.vue";
import axios from "axios"
export default {
    mixins: [config.globalMixin],
    data() {
        return {
            page: 1, //当前页数
            pagesize: 10, //一页显示几条
            total: 0,
            rows: [],
            canDrag: true,
            deliveryId: '',
            endGiftStoreId: '',
            giftStoreList: []
        };
    },
    components: {
        StatusBtn,
    },
    computed: {
        statusMap() {
            return {
                0: "Open",
                1: "Complete",
                2: "Cancel"
            }
        },
        giftStoreMap() {
            return this.giftStoreList.map(i => {
                return {
                    value: i.id,
                    label: i.storeName
                }
            })
        },
    },
    created: function () {
        this.getGitStore()
    },
    methods: {
        async init() {
            this.canDrag = true;
            var objdata = this.getAuthObj();

            objdata.pageIndex = this.page;
            objdata.pageSize = this.pagesize;
            objdata.endGiftStoreId = this.endGiftStoreId;
            objdata.deliveryNo = this.deliveryId
            objdata.apiUrl = this.apiConfig.giftDeliveryList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.rows = data.data.result.giftDeliveryList;
            this.total = data.data.result.total;
        },
        async getGitStore() {
            var objdata = this.getAuthObj();

            objdata.pageIndex = 1;
            objdata.pageSize = 9999;

            objdata.apiUrl = this.apiConfig.giftStoreList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.giftStoreList = data.data.result.giftStoreList;
        },
        async search() {
            this.page = 1;
            this.init();
        },
        async updateStatusEvent(status, id) {
            var objdata = this.getAuthObj();
            objdata.id = id
            objdata.status = status

            objdata.apiUrl = this.apiConfig.giftDeliveryUpdateStatus;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            await this.init()
        },
        cancel: function () {
            this.$store.commit("setwarning", { string: "", boolean: false });
        },
        cell: function ({ row }) {
        },
        async exporttDeliveryNote(item) {
            var objdata = this.getAuthObj();
            let url = `${config.domain}${this.apiConfig.giftDeliveryNote}?id=${item.id}`
            const res = await axios.get(url, {
                headers: {
                    'userId': objdata.userId,
                    'token': objdata.token
                },
                responseType:'blob'
            })
            if (res.status == 200) {
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(res.data);
                link.setAttribute("target", '_blank');
                document.body.appendChild(link);
                link.click();
            }


        },

    },
    mounted() {
        this.init();
    },
};
</script>
  